import AjaxRequest from "./AjaxRequest";
import Slider from "./Slider";

class DitecProductSlider
{

    constructor(overlayController, tabSliderController, debug=false)
    {

        this.overlayController = overlayController;
        this.tabSliderController = tabSliderController;
        this.debug = debug;

        this.productSlider = document.querySelector('.products--slider');
        this.productSlider && this.initProductSlider();

        this.productDetailsAjaxContainer = document.getElementById('product-details');
        this.productDetailsCurrentUri = null;

        /**
         * Load product details via ajax
         *
         * @param uri
         */
        this.loadProductDetails = (uri) =>
        {
            if (uri === this.productDetailsCurrentUri) {
                return;
            }
            // only if uri has changed
            this.holdSectionNavObserver = true;
            document.body.classList.remove('-has-sticky-content-nav'); // or else this nav bar will instantly be attached to the viewport's top
            this.productDetailsAjaxContainer.classList.add('-loading');
            this.productDetailsAjaxContainer.innerHTML = '';
            debug && console.log('[DitecProductSlider]', 'loadProductDetails()', uri);
            const ajaxRequest = new AjaxRequest({
                debug: true,
                url: uri,
                callback: (response) => {
                    if (response) {
                        debug && console.log('[DitecProductSlider]', 'AjaxRequest completed');
                        this.productDetailsAjaxContainer.innerHTML = response;
                        this.tabSliderController.init(
                            this.productDetailsAjaxContainer,
                            (tabSliders) => {
                                for (const tabSlider of tabSliders) {
                                    const anchor = tabSlider.parentNode.firstElementChild;
                                    const id = anchor ? anchor.id : null;
                                    // tabSlider.addEventListener('autoplay', (e) => {
                                    //     const sectionNavItem = document.querySelector(`.products--content-nav a[href*="${id}"]`);
                                    //     //console.log(sectionNavItem);
                                    //     if (e.detail.stopped) {
                                    //         tabSlider.style.setProperty('--autoplay-animation', 'none');
                                    //     }
                                    //     else if (e.detail.started) {
                                    //         tabSlider.style.setProperty('--autoplay-animation', 'autoplay-progress');
                                    //     }
                                    // });
                                    tabSlider.addEventListener('stateChange', (e) => {
                                        if (e.detail.visible) {
                                            const sectionId = tabSlider.id.replace('tabslider-', 'p');
                                            const sectionLink = this.sectionNav.querySelector(`a[href*="${sectionId}"]`);
                                            const sectionNav = document.querySelector('.products__content-nav');
                                            const sectionNavDirectionToggleButton = sectionNav.parentNode.querySelector('button');
                                            for (const sectionNavItem of this.sectionNav.querySelectorAll('a')) {
                                                if (sectionLink === sectionNavItem) {
                                                    sectionNavItem.classList.add('-active');
                                                    if (sectionNavItem.parentNode.parentNode.clientWidth <= sectionNavItem.getBoundingClientRect().x + sectionNavItem.clientWidth) {
                                                        if (!sectionNav.classList.contains('-direction-toggled')) {
                                                            sectionNavDirectionToggleButton.dispatchEvent(new Event('click'));
                                                        }
                                                    }
                                                    else if (0 >= sectionNavItem.getBoundingClientRect().x) {
                                                        if (sectionNav.classList.contains('-direction-toggled')) {
                                                            sectionNavDirectionToggleButton.dispatchEvent(new Event('click'));
                                                        }
                                                    }
                                                }
                                                else {
                                                    sectionNavItem.classList.remove('-active');
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        );
                        setTimeout(() => {
                            this.initSectionNav();
                            this.initOverlays();
                            this.productDetailsAjaxContainer.classList.remove('-loading');
                            this.holdSectionNavObserver = false;
                        }, 1000);
                    }
                }
            });
            ajaxRequest.send();
            this.productDetailsCurrentUri = uri;
        };

    }

    /**
     * Initialise the main product slider
     */
    initProductSlider()
    {
        document.body.classList.add('-nav-is-transparent'); // This will make the navigation transparent
        document.body.classList.add('-additional-content-is-hidden'); // This will hide some headers and content not needed

        const productSliderInstance = new Slider(this.productSlider, {
            debug: false,
            autoplay: false,
            slideMode: Slider.SLIDE_MODE_STRICT,
            gestures: false,
            gesturesWithMouse: false,
            navigation: false,
            controls: true,
            keyboard: false
        });

        // Productsliders implement an ajax loading feature for the content (= product details)
        this.productSlider.addEventListener('slide', (e) => {
            const currentIndex = e.detail.currentIndex;
            const currentItem = e.detail.items[currentIndex];
            const productDetailUri = currentItem.getAttribute('data-product-uri') || null;
            if (null === productDetailUri) {
                return;
            }
            this.loadProductDetails(productDetailUri);
        });

        // Slider reset button:
        const sliderReset = document.getElementById('slider-reset');
        if (sliderReset) {
            try {
                sliderReset.addEventListener('click', () => {
                    productSliderInstance.slideTo(0);
                });
            }
            catch(e) {
                console.error(e);
            }
        }
    }

    /**
     * Initialise the section navigation
     */
    initSectionNav()
    {

        const sectionNav = document.querySelector('.products--content-nav');
        if (!sectionNav) {
            return;
        }

        const sectionNavList = sectionNav.querySelector('ul');

        let width = 0;
        const maxWidth = this.productDetailsAjaxContainer.scrollWidth - 200;
        const scrollButton = sectionNav.querySelector('button');
        scrollButton.style.display = 'none';
        let scrollingPosition = -1;
        let scrollingRequired = false;

        setInterval(() => {
            (() => {
                //console.log('check if scrolling is req');
                for (const sectionLink of sectionNav.querySelectorAll('a[data-section]')) {
                    width += sectionLink.scrollWidth;
                }
                if (width > maxWidth) {
                    scrollingRequired = true;
                    scrollButton.style.display = 'block';
                }
                else {
                    scrollingRequired = false;
                    scrollButton.style.display = 'none';
                }
            })();
        },500);

        // Add sections/hashtags to links (for some reason the typolinks do not accept them)
        for (const sectionLink of sectionNav.querySelectorAll('a[data-section]')) {
            const section = sectionLink.getAttribute('data-section');
            sectionLink.href = window.location.href.split('#')[0] + section;
        }

        scrollButton.addEventListener('click', () => {
            if (!scrollingRequired) return;
            if (0 > scrollingPosition) {
                const diff = sectionNavList.scrollWidth - maxWidth;
                sectionNavList.style.setProperty('--translateX', `-${diff}px`);
                sectionNavList.classList.add('-direction-toggled');
                scrollingPosition = 1;
            }
            else {
                sectionNavList.style.setProperty('--translateX', `0px`);
                sectionNavList.classList.remove('-direction-toggled');
                scrollingPosition = -1;
            }
            sectionNav.setAttribute('data-scrolling-position', scrollingPosition);
        });

        //window.addEventListener('resize', () => {
        //    isScrollingRequired();
        //});

        const intersectionObserverOptions = {
            rootMargin: '0px',
            threshold: 1.0
        }
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // This observer can be haltet or else the navbar would sometimes jump to the top while ajax is still loading
                if (this.holdSectionNavObserver)
                    return;
                if (!entry.isIntersecting && 0 >= entry.boundingClientRect.top) {
                    document.body.classList.add('-has-sticky-content-nav');
                }
                else {
                    document.body.classList.remove('-has-sticky-content-nav');
                }
            });
        }, intersectionObserverOptions);
        intersectionObserver.observe(document.getElementById('content-nav-spacer'));

        this.sectionNav = sectionNav; // make availabe for all functions of this instances

        this.debug && console.log('[DitecProductSlider]', 'initSectionNav()', 'scrollingRequired', scrollingRequired);
    }

    initOverlays()
    {
        this.debug && console.log('[DitecProductSlider]', 'initOverlays()');
        this.overlayController.refresh();
    }

}

export default DitecProductSlider;